import { useEffect } from "react";
import { StyleSheet } from "react-native";
import Animated, {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withRepeat,
  withSequence,
  withTiming,
} from "react-native-reanimated";
import ThemedText from "../core/ThemedText";

export function HelloWave() {
  const rotationAnimation = useSharedValue(0);
  const scaleAnimation = useSharedValue(1);
  const opacityAnimation = useSharedValue(1);

  useEffect(() => {
    rotationAnimation.value = withRepeat(
      withSequence(
        withTiming(0, { duration: 500 }),
        withTiming(25, {
          duration: 200,
          easing: Easing.out(Easing.quad),
        }),
        withTiming(-15, {
          duration: 150,
          easing: Easing.inOut(Easing.quad),
        }),
        withTiming(20, {
          duration: 150,
          easing: Easing.inOut(Easing.quad),
        }),
        withTiming(-10, {
          duration: 120,
          easing: Easing.inOut(Easing.quad),
        }),
        withTiming(10, {
          duration: 120,
          easing: Easing.inOut(Easing.quad),
        }),
        withTiming(0, {
          duration: 300,
          easing: Easing.out(Easing.quad),
        }),
        withDelay(2000, withTiming(0, { duration: 0 }))
      ),
      -1,
      false
    );

    scaleAnimation.value = withRepeat(
      withSequence(
        withTiming(1.05, {
          duration: 1500,
          easing: Easing.inOut(Easing.sin),
        }),
        withTiming(1, {
          duration: 1500,
          easing: Easing.inOut(Easing.sin),
        })
      ),
      -1,
      false
    );

    opacityAnimation.value = withRepeat(
      withSequence(
        withTiming(0.8, {
          duration: 2000,
          easing: Easing.inOut(Easing.sin),
        }),
        withTiming(1, {
          duration: 2000,
          easing: Easing.inOut(Easing.sin),
        })
      ),
      -1,
      false
    );
  }, []);

  const animatedStyle = useAnimatedStyle(() => ({
    transform: [
      { rotate: `${rotationAnimation.value}deg` },
      { scale: scaleAnimation.value },
    ],
    opacity: opacityAnimation.value,
  }));

  return (
    <Animated.View style={[styles.container, animatedStyle]}>
      <ThemedText style={styles.text}>👋</ThemedText>
    </Animated.View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 8,
    marginTop: 4,
  },
  text: {
    fontSize: 32,
    lineHeight: 36,
    textAlign: "center",

    textShadowColor: "rgba(0, 0, 0, 0.1)",
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 2,
  },
});
